import type { AuthProvider } from "@refinedev/core";
import { axiosInstance } from "../api/client";
import type { User } from "../types";

interface GoogleLoginParams {
  idToken: string;
  returnTo?: string;
}

export const authProvider: AuthProvider = {
  login: async (params: unknown) => {
    const { idToken, returnTo } = params as Partial<GoogleLoginParams>;

    if (idToken) {
      const { data } = await axiosInstance.post<{ accessToken: string; user: User }>(
        "/auth/google",
        { idToken }
      );
      localStorage.setItem("lp_token", data.accessToken);
      localStorage.setItem("lp_user", JSON.stringify(data.user));
    } else {
      // Dev bypass: MSW intercepts /auth/me with mock data
      const { data: user } = await axiosInstance.get<User>("/auth/me");
      localStorage.setItem("lp_user", JSON.stringify(user));
      localStorage.setItem("lp_token", `mock_${Date.now()}`);
    }

    return { success: true, redirectTo: returnTo ?? "/tokens" };
  },

  logout: async () => {
    localStorage.removeItem("lp_user");
    localStorage.removeItem("lp_token");
    return { success: true, redirectTo: "/login" };
  },

  check: async () => {
    const token = localStorage.getItem("lp_token");
    return token
      ? { authenticated: true }
      : { authenticated: false, logout: true, redirectTo: "/login" };
  },

  onError: async (error) => {
    return { error };
  },

  getIdentity: async () => {
    const raw = localStorage.getItem("lp_user");
    return raw ? JSON.parse(raw) : null;
  },

  getPermissions: async () => null,
};
